"use strict";
import { ButtonSize } from "../Button/Button";
export const getButtonSize = (fieldSize = "medium") => {
  switch (fieldSize) {
    case "small": {
      return ButtonSize.Small;
    }
    case "medium": {
      return ButtonSize.Medium;
    }
    case "large": {
      return ButtonSize.Large;
    }
    default: {
      return ButtonSize.Medium;
    }
  }
};
export const getTextInputSize = (fieldSize = "medium") => {
  switch (fieldSize) {
    case "small": {
      return "s";
    }
    case "medium": {
      return "m";
    }
    case "large": {
      return "l";
    }
  }
};
export const getSegmentedControlSize = (fieldSize = "medium") => {
  switch (fieldSize) {
    case "small": {
      return "s";
    }
    case "medium": {
      return "m";
    }
    case "large": {
      return "l";
    }
  }
};
export const getSelectSize = (fieldSize = "medium") => {
  switch (fieldSize) {
    case "small": {
      return "s";
    }
    case "medium": {
      return "m";
    }
    case "large": {
      return "l";
    }
  }
};
export const getCheckboxSize = (fieldSize = "medium") => {
  switch (fieldSize) {
    case "small": {
      return "s";
    }
    case "medium": {
      return "m";
    }
    case "large": {
      return "l";
    }
  }
};
